export default "__VITE_ASSET__BYNr0OCA__"